import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.css']
})
export class ValidationComponent implements OnInit {
  model: any = {};

  onSubmit() {
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.model, null, 4));
  }
  constructor() { }

  ngOnInit() {
  }

}
